export const search = {

  namespaced: true,

  state: {
    query: {
       locality: '',
       latitude: null,
       longitude: null
    },
  },

  actions: {
    query({commit}, payload) {
      commit('updateQuery', payload);
    }
  },

  mutations: {
    updateQuery(state, payload) {
      state.query = payload
    }
  }
};
